"use client";
// skill-ack: ui-page repo skill file is not registered in this repo (see
// AddressField.tsx) -- generalizing GuestPlacementNotice.tsx's exact
// alert-box markup for two placement-warning scenarios instead of one, no
// new primitives, no restyled primitives.

import { Danger } from "iconsax-reactjs";
import { useTranslations } from "next-intl";

interface PlacementWarningNoticeProps {
  /** Full `checkout.*` message key to render inside the notice body. */
  messageKey: string;
}

/**
 * Persistent disclosure for an irreversible placement decision that is about
 * to happen on THIS purchase — either electing permanent-guest status (a
 * blank referrer on a first purchase) or locking in a tree position (a
 * purchase that crosses the 10bv placement threshold). Both are supported,
 * intentional outcomes, not errors — this is a heads-up, not a warning about
 * a mistake, so the page additionally makes the buyer confirm before anything
 * is minted rather than blocking them here.
 */
export const PlacementWarningNotice = ({
  messageKey,
}: PlacementWarningNoticeProps) => {
  const t = useTranslations();

  return (
    <div className="rounded-sm border border-semantic-alert/40 bg-semantic-alert/5 p-3">
      <div className="flex items-start gap-2">
        <Danger
          size={16}
          variant="Bold"
          className="text-semantic-alert shrink-0 mt-0.5"
        />
        <p className="text-xs leading-relaxed text-text-primary">
          {t(messageKey)}
        </p>
      </div>
    </div>
  );
};
